import { render, staticRenderFns } from "./CreditCardsPage.vue?vue&type=template&id=3f9542f9&scoped=true&"
import script from "./CreditCardsPage.vue?vue&type=script&lang=ts&"
export * from "./CreditCardsPage.vue?vue&type=script&lang=ts&"
import style0 from "./CreditCardsPage.vue?vue&type=style&index=0&id=3f9542f9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f9542f9",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
installComponents(component, {VBtn,VCard,VCardText,VCardTitle,VSimpleTable,VSpacer,VSwitch})
